var _path, _path2, _path3, _path4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7664_194878",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5381 1H17.0547L17.6163 7.1106C17.6163 7.1106 18.7394 8.33272 20.4242 8.33272C21.6339 8.33272 22.4575 7.70266 22.8259 7.34732C22.9727 7.2057 23.0264 6.9895 22.9941 6.77893L22.2027 1.61272C22.1486 1.25915 21.8675 1 21.5381 1Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0543 1L17.6159 7.1106C17.6159 7.1106 16.4927 8.33272 14.8079 8.33272C13.1232 8.33272 12 7.1106 12 7.1106V1H17.0543Z",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9987 1V7.1106C11.9987 7.1106 10.8755 8.33272 9.19074 8.33272C7.50598 8.33272 6.38281 7.1106 6.38281 7.1106L6.9444 1H11.9987Z",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94848 1H2.46508C2.13566 1 1.85452 1.25915 1.80036 1.61272L1.00903 6.77894C0.976779 6.9895 1.0305 7.2057 1.1773 7.34732C1.54561 7.70266 2.36925 8.33272 3.57894 8.33272C5.2637 8.33272 6.3869 7.1106 6.3869 7.1106L6.94848 1Z",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90625 8.33496V20.5562C1.90625 21.9061 2.91197 23.0004 4.15259 23.0004H19.877C21.1177 23.0004 22.1233 21.9061 22.1233 20.5562V8.33496",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 22.9986V15.6659C15.2 14.316 14.1943 13.2217 12.9536 13.2217H10.7073C9.46666 13.2217 8.46094 14.316 8.46094 15.6659V22.9986",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7664_194878)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.945312,
    y: -0.832031,
    width: 25.0902,
    height: 25.2062,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.59e3175e33bd6a6c2337163c326cfe62.svg";
export { ForwardRef as ReactComponent };